const ptClasses = {
    0: "Zug",
    1: "S-Bahn",
    2: "U-Bahn",
    3: "Stadtbahn",
    4: "Straßenbahn",
    5: "Schnellbus",
    6: "Regionalbus",
    7: "Stadtbus",
    8: "Seil-/Zahnradbahn",
    9: "Schiff",
    10: "Anrufsammeltaxi/Rufbus",
    11: "Sonstige",
    12: "Autoreisezug",
    13: "Nicht in Verwendung",
    14: "Nicht in Verwendung",
    15: "Nicht in Verwendung",
}

const colorSchemeHin = ["#628395","#96897B", "#DFD5A5", "#DBAD6A",
    "#CF995F", "#CBE896", "#AAC0AA","#FCDFA6","#A18276", "#F4B886",
    "#FDE8E9", "#E3BAC6", "#BC9EC1", "#596475", "#1F2232"]
const colorSchemeRueck = ["rgba(98,131,149,0.7)","rgba(150,137,123,0.7)", "rgba(223,213,165,0.7)", "rgba(219,173,106,0.7)",
    "rgba(207,153,95,0.7)", "rgba(203,232,150,0.7)", "rgba(170,192,170,0.7)","rgba(252,223,166,0.7)",
    "rgba(253,232,233,0.7)", "rgba(227,186,198,0.7)", "rgba(188,158,193,0.7)", "rgba(89,100,117,0.7)"]

export function getPtClassName(string){
    return ptClasses[string]
}

export function getPtClass(chartLabel){
    let ptClassName = chartLabel.split('- ')[1]
    return Object.keys(ptClasses).find(key => ptClasses[key] === ptClassName)
}

export function getClassColor(string, direction) {
    return direction === "hinfahrt" ? colorSchemeHin[parseInt(string)] : colorSchemeRueck[parseInt(string)];
}
